'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import { useParams } from 'next/navigation'
import { useTranslator } from '@/hooks'
import { LANG } from '@/utils'
import type { TypeLang } from '@/schema'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error }: Props) {
  const { t } = useTranslator()
  const { lang } = useParams() as { lang?: TypeLang }
  const currentLang = lang || LANG

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <section className='s--error'>
      <h1>{t('page_error.500')}</h1>
      <h2>{t('page_error.title')}</h2>
      <p>{t('page_error.description')}</p>
      <Link href={`/${currentLang}`}>{t('page_error.goback_homepage')}</Link>
    </section>
  )
}
